import { render, staticRenderFns } from "./VotePieChartRender.vue?vue&type=template&id=22a8ca24&scoped=true"
import script from "./VotePieChartRender.vue?vue&type=script&lang=js"
export * from "./VotePieChartRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8ca24",
  null
  
)

export default component.exports